import { Typography } from '@mui/material';

export const SendingOrderStatusBadge = () => {
  interface IOrderStatus {
    label: string;
    color: string;
  }

  const statusArray: IOrderStatus[] = [
    {
      label: 'Klar',
      color: 'success.main',
    },
    {
      label: 'Pågående',
      color: 'warning.dark',
    },
    {
      label: 'Utkast',
      color: 'info.dark',
    },
  ];

  const randomElement = statusArray[Math.floor(Math.random() * statusArray.length)];

  return (
    <Typography
      variant='caption'
      display='block'
      sx={{
        py: 1 / 4,
        px: 2,
        color: 'info.contrastText',
        backgroundColor: randomElement.color,
        borderRadius: 'shape.borderRadius',
      }}
    >
      {randomElement.label}
    </Typography>
  );
};
